import AxiosInstance from "@/components/Axios"
import { BidFormCreationProps } from "@/interfaces/bid_types"

export function getBid(bid_id: string) {
    return AxiosInstance.get(`api/bids/id/${bid_id}`)
}

export function createBid(bid: BidFormCreationProps) {
    return AxiosInstance.post("api/bids/", bid)
}

export function updateBid(bid: BidFormCreationProps) {
    return AxiosInstance.put(`api/bids/id/${bid.bid_id}`, bid)
}

export function deleteBid(bid_id: string) {
    return AxiosInstance.delete(`api/bids/id/${bid_id}`)
}